var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUniform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 436.704 436.704",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#158E9B"
    },
    points: "386.352,380.704 386.352,388.704 370.352,388.704 370.352,404.704 386.352,404.704  386.352,420.704 282.352,420.704 282.352,404.704 354.352,404.704 354.352,388.704 282.352,388.704 282.352,380.704 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D9AAE"
    },
    d: "M353.552,86.304l-7.2,7.2v58.4c0,79.2-36.8,160.8-91.2,209.6c-8,7.2-16,12.8-24.8,18.4 c-0.8,0.8-2.4,0.8-4,0.8s-3.2,0-4-1.6c-68-43.2-116-136.8-116-227.2v-58.4l-15.2-15.2l-72.8,66.4v276h200v-16h16v16h32v-48 c0-3.2,2.4-6.4,4.8-7.2c0.8,0,2.4-0.8,3.2-0.8h120c4,0,8,4,8,8v48h16v-276L353.552,86.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E94545"
    },
    d: "M259.152,212.704l15.2,104c-14.4,18.4-30.4,34.4-48,46.4c-17.6-12-33.6-28-48-46.4l15.2-104H259.152z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE5656"
    },
    d: "M248.752,212.704l9.6,104c-9.6,18.4-20,34.4-32,46.4c-12-12-22.4-28-32-46.4l9.6-104H248.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E94545"
    },
    d: "M227.152,110.304l43.2,43.2l10.4,32l-16.8,11.2h-75.2l-16.8-11.2l10.4-32l43.2-43.2l0.8-0.8 L227.152,110.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9CDC1"
    },
    d: "M147.152,20.704h159.2l-8,8h-48v16h31.2l-54.4,54.4l-0.8,0.8l-0.8-0.8l-54.4-54.4h55.2v-16h-71.2 L147.152,20.704z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M177.552,208.704l-12.8,88.8c-26.4-42.4-42.4-94.4-42.4-145.6v-42.4l43.2,43.2l-11.2,33.6 c-0.8,3.2,0,7.2,3.2,8.8L177.552,208.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M330.352,109.504v42.4c0,51.2-16,103.2-42.4,145.6l-12.8-88.8l20-12.8c3.2-2.4,4-5.6,3.2-8.8 l-11.2-33.6L330.352,109.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M87.952,43.904l26.4-25.6c0.8-0.8,2.4-1.6,4-1.6s3.2,0.8,4,1.6l86.4,86.4l-33.6,33.6l-87.2-85.6 C85.552,50.304,85.552,46.304,87.952,43.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M337.552,17.504l28.8,28.8c1.6,1.6,1.6,4,0,4.8l-88,88l-33.6-33.6l88-88 C333.552,15.904,335.952,15.904,337.552,17.504z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M174.352,139.104l33.6-33.6l-85.6-87.2c-0.8-0.8-2.4-1.6-4-1.6s-3.2,0.8-4,1.6l-25.6,25.6 c-2.4,2.4-2.4,6.4,0,8L174.352,139.104z M164.752,297.504l12.8-88.8l-20-12.8c-3.2-2.4-4-5.6-3.2-8.8l11.2-33.6l-43.2-44v42.4 C122.352,203.104,138.352,255.104,164.752,297.504z M280.752,185.504l-10.4-32l-43.2-43.2l-0.8-0.8l-0.8,0.8l-43.2,43.2l-10.4,32 l16.8,11.2h75.2L280.752,185.504z M274.352,316.704l-15.2-104h-66.4l-14.4,104c14.4,18.4,30.4,34.4,48,46.4 C243.952,351.104,259.952,335.104,274.352,316.704z M297.552,28.704l8-8h-158.4l8,8h71.2v16h-55.2l54.4,54.4l0.8,0.8l0.8-0.8 l54.4-54.4h-31.2v-16H297.552z M330.352,151.904v-42.4l-43.2,43.2l11.2,33.6c0.8,3.2,0,7.2-3.2,8.8l-20,12.8l12.8,88.8 C314.352,255.104,330.352,203.104,330.352,151.904z M366.352,51.104c1.6-1.6,1.6-4,0-4.8l-28.8-28.8c-1.6-1.6-4-1.6-5.6,0l-88,88 l33.6,33.6L366.352,51.104z M386.352,420.704v-16h-16v-16h16v-8h-104v8h72v16h-72v16H386.352z M418.352,420.704v-276l-64.8-57.6 l-7.2,6.4v58.4c0,79.2-36.8,160.8-91.2,208.8c-8,7.2-16,13.6-24.8,18.4c-0.8,1.6-2.4,1.6-4,1.6s-3.2,0-4-1.6 c-68-43.2-116-136.8-116-227.2v-58.4l-15.2-14.4l-72.8,65.6v276h200v-16h16v16h32v-48c0-3.2,2.4-6.4,4.8-7.2 c0.8-0.8,2.4-0.8,3.2-0.8h120c4,0,8,4,8,8v48H418.352z M434.352,140.704v288c0,4-4,8-8,8h-32h-120h-264c-4.8,0-8-4-8-8v-288 c0-2.4,0.8-4,2.4-5.6l75.2-68l-3.2-3.2c-8.8-8.8-8.8-22.4,0-31.2l25.6-25.6c4-4,9.6-6.4,15.2-6.4c4.8,0,8.8,1.6,12.8,4h192 c8-6.4,19.2-6.4,26.4,0.8l28.8,28.8c8,8,8,20,0,28l-12.8,12.8l67.2,59.2C433.552,135.904,434.352,138.304,434.352,140.704z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B7C82"
    },
    d: "M86.352,83.104l-68,61.6v260l20-209.6c2.4-24.8,10.4-49.6,23.2-71.2L86.352,83.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B7C82"
    },
    d: "M353.552,86.304L353.552,86.304l21.6,37.6c12.8,21.6,20.8,45.6,23.2,71.2l20,209.6v-260 L353.552,86.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9CDC1"
    },
    d: "M175.952,137.504l-58.4-72c-7.2-8.8-9.6-19.2-6.4-30.4l3.2-14.4l-1.6-1.6l-24.8,25.6 c-2.4,2.4-2.4,6.4,0,8l77.6,77.6L175.952,137.504L175.952,137.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9CDC1"
    },
    d: "M276.752,137.504l58.4-72c7.2-8.8,9.6-19.2,6.4-30.4l-3.2-14.4l1.6-1.6l24.8,24.8 c2.4,2.4,2.4,6.4,0,8l-77.6,77.6L276.752,137.504L276.752,137.504z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniform);
export default __webpack_public_path__ + "static/media/uniform.7181d8d797be9350240a9f1404f26ef5.svg";
export { ForwardRef as ReactComponent };